"use strict";

module.exports = /* @ngInject */ function(
  openFinWebClientApiFactory,
  RediPlusWindowRepository,
  RediWindowRepository,
  sideBySideApi,
  $q,
  $log
) {
  var that = this;

  that.handleWindowOpenedEvent = function(rediPlusWindow) {
    return openFinWebClientApiFactory
      .isEikonUser()
      .then(isEikonUser => {
        if (isEikonUser) {
          const maybeExistingSideBySideId = RediPlusWindowRepository.getSideBySideIdFromWorkspace(
            rediPlusWindow.windowId
          );
          return sideBySideApi.rediPlusWindowOpened(
            rediPlusWindow.windowName,
            rediPlusWindow.windowType,
            maybeExistingSideBySideId
          );
        } else {
          return $q.when();
        }
      })
      .then(instanceIdOrNull => {
        if (_.isFunction(instanceIdOrNull)) {
          $log.error(
            "Unexpected skip adding" +
              rediPlusWindow.windowName +
              " to RediPlusWindowRepository as we got back a function: " +
              instanceIdOrNull
          );
          return $q.when();
        } else {
          return RediPlusWindowRepository.add(
            rediPlusWindow.windowId,
            instanceIdOrNull,
            rediPlusWindow.windowType,
            rediPlusWindow.windowName
          );
        }
      })
      .catch(function(data) {
        $log.error(
          "Not able to handle REDI+ window opened event: " +
            JSON.stringify(data)
        );
      });
  };

  that.handleWindowClosedEvent = function(rediPlusWindow) {
    return openFinWebClientApiFactory
      .isEikonUser()
      .then(isEikonUser => {
        if (isEikonUser) {
          const sideBySideInstanceId = RediPlusWindowRepository.getSideBySideInstanceId(
            rediPlusWindow.windowId
          );
          return sideBySideApi.rediPlusWindowClosed(sideBySideInstanceId);
        } else {
          return $q.when();
        }
      })
      .finally(function() {
        RediPlusWindowRepository.remove(rediPlusWindow.windowId);
        return;
      });
  };

  that.handleRegisterLink = function(sourceWindowId, targetNativeWindowId) {
    var sourceSideBySideInstanceId = RediPlusWindowRepository.getSideBySideInstanceId(
      sourceWindowId
    );
    RediWindowRepository.getWindowByNativeId(targetNativeWindowId).then(
      function(targetRediWindow) {
        if (targetRediWindow.isEikonWindow()) {
          sideBySideApi.addLink(
            sourceSideBySideInstanceId,
            targetRediWindow.getInstanceName()
          );
        }
      }
    );
  };

  that.handleUnregisterLink = function(sourceWindowId, targetNativeWindowId) {
    var sourceSideBySideInstanceId = RediPlusWindowRepository.getSideBySideInstanceId(
      sourceWindowId
    );
    RediWindowRepository.getWindowByNativeId(targetNativeWindowId).then(
      function(targetRediWindow) {
        if (targetRediWindow.isEikonWindow()) {
          sideBySideApi.removeLink(
            sourceSideBySideInstanceId,
            targetRediWindow.getInstanceName()
          );
        }
      }
    );
  };

  that.handleContextChanged = function(entity, sourceWindowId) {
    var sideBySideInstanceId = RediPlusWindowRepository.getSideBySideInstanceId(
      sourceWindowId
    );
    if (sideBySideInstanceId) {
      sideBySideApi.contextChanged(sideBySideInstanceId, entity);
    }
  };
};



// WEBPACK FOOTER //
// ./app/business/rediPlusWindowService.js